(() => {
	const DEFAULT_CONFIG = {
		endpoint: "https://benedetti-chat-proxy.benedettichatbot.workers.dev/api/chat",
		statusEndpoint: "",
		includePageContext: true,
		clientId: "000000000",
		title: "Discuter avec nous",
		placeholder: "Écrivez votre message...",
		welcomeMessage: "Bonjour. Comment puis-je vous aider aujourd'hui ?",
	};

	const STYLE_ID = "benedetti-chatbot-styles";
	const ROOT_ID = "benedetti-chatbot-root";
	const STORAGE_KEY = "benedetti-chatbot-state";

	function createSessionId() {
		if (window.crypto?.randomUUID) {
			return window.crypto.randomUUID();
		}

		return `chat_${Date.now()}_${Math.random().toString(16).slice(2)}`;
	}

	function readChatState() {
		try {
			const rawState = window.localStorage.getItem(STORAGE_KEY);
			if (!rawState) return null;
			const parsedState = JSON.parse(rawState);
			if (!parsedState || typeof parsedState !== "object") return null;
			return {
				id: typeof parsedState.id === "string" && parsedState.id ? parsedState.id : null,
				open: Boolean(parsedState.open),
				messages: Array.isArray(parsedState.messages) ? parsedState.messages.filter((item) => item && typeof item === "object" && typeof item.role === "string" && typeof item.text === "string") : [],
			};
		} catch {
			return null;
		}
	}

	function writeChatState(state) {
		try {
			window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
		} catch {
			// Ignore storage failures and keep the widget usable.
		}
	}

	function injectStyles() {
		if (document.getElementById(STYLE_ID)) return;

		const style = document.createElement("style");
		style.id = STYLE_ID;
		style.textContent = `
			#${ROOT_ID} {
				position: fixed;
				right: max(clamp(12px, 2vw, 20px), env(safe-area-inset-right, 0px) + 12px);
				bottom: max(clamp(12px, 2vw, 20px), env(safe-area-inset-bottom, 0px) + 12px);
				z-index: 2147483647;
				font-family: Roboto, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
				color: #2f241e;
			}

			#${ROOT_ID} * {
				box-sizing: border-box;
			}

			.bc-button {
				width: clamp(54px, 4.5vw, 60px);
				height: clamp(54px, 4.5vw, 60px);
				border: 0;
				border-radius: 999px;
				background: linear-gradient(135deg, #acdba3 0%, #c9eac1 100%);
				color: #2f241e;
				box-shadow: 0 10px 22px rgba(47, 36, 30, 0.18);
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				line-height: 0;
				cursor: pointer;
				border: 1px solid rgba(74, 52, 40, 0.12);
				transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease, background 160ms ease;
				animation: bc-float 4s ease-in-out infinite;
			}

			.bc-button:hover {
				transform: translateY(-2px) scale(1.02);
				box-shadow: 0 14px 28px rgba(47, 36, 30, 0.22);
				filter: brightness(1.02);
			}

			.bc-button svg {
				display: block;
				width: 36px;
				height: 36px;
				flex: 0 0 auto;
				transform: translateY(-2px);
				filter: drop-shadow(0 1px 0 rgba(255, 255, 255, 0.35));
			}

			@media (max-width: 640px) {
				#${ROOT_ID} {
					right: max(10px, env(safe-area-inset-right, 0px) + 10px);
					bottom: max(10px, env(safe-area-inset-bottom, 0px) + 10px);
				}

				.bc-button {
					width: 56px;
					height: 56px;
				}

				.bc-button svg {
					width: 34px;
					height: 34px;
				}
			}

			.bc-panel {
				position: absolute;
				right: 0;
				bottom: clamp(70px, 8vw, 76px);
				width: min(380px, calc(100vw - 24px));
				height: min(560px, calc(100vh - 96px));
				background: rgba(252, 250, 247, 1);
				border: 1px solid rgba(47, 36, 30, 0.22);
				border-radius: 24px;
				box-shadow: 0 10px 20px rgba(47, 36, 30, 0.12);
				display: none;
				overflow: hidden;
				backdrop-filter: blur(12px);
				flex-direction: column;
				font-size: 12px;
			}

			.bc-panel.open {
				display: flex;
				animation: bc-panel-in 180ms ease-out both;
			}

			.bc-header {
				position: relative;
				display: block;
				padding: 16px 18px;
				padding-right: 60px;
				background: linear-gradient(135deg, #4a3428 0%, #5c4334 100%);
				color: #f8f4ef;
				border-bottom: 1px solid rgba(255, 255, 255, 0.12);
				box-shadow: 0 2px 8px rgba(47, 36, 30, 0.08);
			}

			.bc-reset-button {
				position: absolute;
				top: 14px;
				right: 14px;
				width: 28px;
				height: 28px;
				border: 1px solid rgba(255, 255, 255, 0.22);
				border-radius: 999px;
				background: rgba(255, 255, 255, 0.12);
				color: #f8f4ef;
				font-size: 16px;
				line-height: 1;
				cursor: pointer;
				display: inline-flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				transition: transform 160ms ease, background 160ms ease, border-color 160ms ease;
			}

			.bc-reset-button:hover {
				transform: translateY(-1px);
				background: rgba(255, 255, 255, 0.18);
				border-color: rgba(255, 255, 255, 0.34);
			}

			.bc-title {
				margin: 0;
				font-family: Butler-Free-Bd, Georgia, serif;
				font-size: 19px;
				font-weight: 400;
				letter-spacing: 0.01em;
				color: #f8f4ef;
				text-shadow: 0 1px 1px rgba(47, 36, 30, 0.14);
			}

			.bc-subtitle {
				margin: 4px 0 0;
				font-size: 13px;
				opacity: 0.9;
				color: rgba(248, 244, 239, 0.92);
			}

			.bc-messages {
				flex: 1;
				padding: 16px;
				overflow: auto;
				display: flex;
				flex-direction: column;
				gap: 10px;
				background:
					radial-gradient(circle at top left, rgba(172, 219, 163, 0.44), transparent 35%),
					linear-gradient(180deg, #f4efe8 0%, #ffffff 100%);
			}

			.bc-message {
				max-width: 85%;
				padding: 10px 12px;
				margin: 0;
				border-radius: 16px;
				font-size: 13px;
				line-height: 1.45;
				white-space: pre-wrap;
				word-break: break-word;
				align-self: flex-start;
				animation: bc-message-in 180ms ease-out both;
				box-shadow: 0 4px 12px rgba(47, 36, 30, 0.08);
			}

			.bc-message.user {
				align-self: flex-end;
				background: linear-gradient(135deg, #acdba3 0%, #d8eed1 100%);
				color: #2f241e;
				border-bottom-right-radius: 6px;
				border: 1px solid rgba(47, 36, 30, 0.1);
			}

			.bc-message.bot {
				align-self: flex-start;
				background: #fff;
				color: #2f241e;
				border: 2px solid rgba(47, 36, 30, 0.22);
				border-bottom-left-radius: 6px;
				box-shadow: 0 4px 12px rgba(47, 36, 30, 0.08);
			}

			.bc-message.error {
				align-self: flex-start;
				background: #fff5f2;
				color: #b91c1c;
				border: 1px solid rgba(185, 28, 28, 0.15);
			}

			.bc-message.bot ul,
			.bc-message.bot ol,
			.bc-message.error ul,
			.bc-message.error ol {
				margin: 8px 0 8px 18px;
				font-size: inherit;
				line-height: inherit;
				padding: 0;
			}

			.bc-message.bot p,
			.bc-message.error p {
				margin: 0 0 8px;
				font-size: inherit;
				line-height: inherit;
			}

			.bc-message.bot li,
			.bc-message.error li {
				font-size: inherit;
				line-height: inherit;
			}

			.bc-message.bot p:last-child,
			.bc-message.error p:last-child {
				margin-bottom: 0;
			}

			.bc-message.bot h3,
			.bc-message.error h3 {
				margin: 12px 0 8px;
				font-size: 17px;
				line-height: 1.3;
				font-family: Butler-Free-Bd, Georgia, serif;
				color: #4a3428;
			}

			.bc-message.bot blockquote,
			.bc-message.error blockquote {
				margin: 12px 0;
				padding: 12px 14px;
				border-left: 6px solid #acdba3;
				border-radius: 14px;
				background: rgba(172, 219, 163, 0.12);
				color: #4a3428;
			}

			.bc-message.bot blockquote p:last-child,
			.bc-message.error blockquote p:last-child {
				margin-bottom: 0;
			}

			.bc-message.bot ul[data-bc-task-list],
			.bc-message.bot ol[data-bc-task-list] {
				list-style: none;
				margin: 10px 0 0;
				padding: 0;
				display: grid;
				gap: 8px;
			}

			.bc-message.bot ul[data-bc-task-list] li,
			.bc-message.bot ol[data-bc-task-list] li {
				margin: 0;
			}

			.bc-task-choice {
				display: flex;
				align-items: center;
				gap: 8px;
				padding: 10px 12px;
				border: 2px solid rgba(74, 52, 40, 0.34);
				border-radius: 14px;
				background: rgba(255, 255, 255, 0.96);
				color: #2f241e;
				font-size: 12px;
				line-height: 1.35;
				justify-content: flex-start;
				text-align: left;
				cursor: pointer;
				transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease, background 140ms ease;
			}

			.bc-task-choice::before {
				content: none;
			}

			.bc-task-choice:hover {
				transform: translateY(-1px);
				border-color: rgba(74, 52, 40, 0.52);
				box-shadow: 0 8px 18px rgba(47, 36, 30, 0.08);
				background: rgba(255, 255, 255, 1);
			}

			.bc-task-choice.bc-task-choice--checked {
				border-color: rgba(95, 143, 82, 0.75);
				background: linear-gradient(135deg, rgba(172, 219, 163, 0.58), rgba(255, 255, 255, 0.98));
			}

			.bc-task-choice.bc-task-choice--checked::before {
				content: none;
			}

			.bc-interaction-block {
				margin-top: 12px;
				padding: 12px 12px 10px;
				border: 2px solid rgba(74, 52, 40, 0.14);
				border-radius: 16px;
				background: linear-gradient(180deg, rgba(247, 243, 238, 0.98), rgba(255, 255, 255, 0.98));
			}

			.bc-interaction-title {
				margin: 0 0 10px;
				font-size: 14px;
				font-weight: 700;
				color: #4a3428;
			}

			.bc-interaction-list {
				margin: 0;
				padding: 0;
				list-style: none;
				display: grid;
				gap: 8px;
			}

			.bc-image-card {
				margin: 10px 0 12px;
				padding: 8px;
				border: 2px solid rgba(47, 36, 30, 0.12);
				border-radius: 18px;
				background: rgba(248, 244, 239, 0.9);
				overflow: hidden;
			}

			.bc-image-card img {
				display: block;
				width: 100%;
				height: auto;
				max-width: 100%;
				border-radius: 12px;
				object-fit: cover;
			}

			.bc-image-caption {
				margin: 8px 2px 0;
				font-size: 13px;
				line-height: 1.4;
				color: rgba(47, 36, 30, 0.76);
			}

			.bc-link-button {
				display: inline-flex;
				align-items: center;
				gap: 8px;
				position: relative;
				margin: 2px 0;
				padding: 9px 12px;
				border-radius: 12px;
				border: 1px solid rgba(47, 36, 30, 0.14);
				background: linear-gradient(135deg, rgba(172, 219, 163, 0.44), rgba(255, 255, 255, 0.98));
				color: #2f241e;
				font: inherit;
				font-weight: 700;
				vertical-align: baseline;
				cursor: pointer;
				transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease, background 160ms ease;
				z-index: 0;
			}

			.bc-link-button:hover {
				transform: translateY(-1px);
				box-shadow: 0 8px 20px rgba(47, 36, 30, 0.08);
				border-color: rgba(47, 36, 30, 0.22);
				background: linear-gradient(135deg, rgba(172, 219, 163, 0.58), rgba(255, 255, 255, 0.98));
				z-index: 3;
			}

			.bc-link-button::after {
				content: "↗";
				font-size: 12px;
				opacity: 0.78;
			}

			.bc-link-popover {
				position: absolute;
				left: 0;
				top: calc(100% + 10px);
				width: min(240px, calc(100vw - 48px));
				padding: 8px;
				border-radius: 16px;
				border: 1px solid rgba(47, 36, 30, 0.12);
				background: rgba(255, 255, 255, 0.98);
				box-shadow: 0 14px 28px rgba(47, 36, 30, 0.14);
				opacity: 0;
				visibility: hidden;
				transform: translateY(6px);
				transition: opacity 150ms ease, transform 150ms ease, visibility 150ms ease;
				z-index: 20;
				pointer-events: none;
				display: flex;
				align-items: flex-start;
				gap: 8px;
			}

			.bc-link-button:hover .bc-link-popover,
			.bc-link-button:focus-visible .bc-link-popover {
				opacity: 1;
				visibility: visible;
				transform: translateY(0);
			}

			.bc-link-button:hover .bc-link-popover,
			.bc-link-button:focus-visible .bc-link-popover,
			.bc-link-button:focus-within .bc-link-popover {
				z-index: 30;
			}

			.bc-link-popover__image {
				flex: 0 0 58px;
				width: 58px;
				height: 58px;
				border-radius: 10px;
				overflow: hidden;
				background: transparent;
				margin-bottom: 0;
			}

			.bc-link-popover__image img {
				display: block;
				width: 100%;
				height: 100%;
				object-fit: cover;
			}

			.bc-link-popover__image[hidden] {
				display: none;
			}

			.bc-link-popover__content {
				flex: 1 1 auto;
				min-width: 0;
				display: flex;
				flex-direction: column;
				gap: 3px;
			}

			.bc-link-popover__title {
				margin-top: 0;
			}

			.bc-link-popover__title {
				display: block;
				font-size: 13px;
				font-weight: 700;
				line-height: 1.35;
				margin-bottom: 0;
			}

			.bc-link-popover__desc {
				display: block;
				font-size: 12px;
				line-height: 1.4;
				color: rgba(47, 36, 30, 0.78);
			}

			.bc-footer {
				padding: 12px;
				border-top: 1px solid rgba(74, 52, 40, 0.08);
				background: rgba(255, 255, 255, 0.98);
			}

			.bc-form {
				display: flex;
				gap: 10px;
				align-items: flex-end;
			}

			.bc-input {
				flex: 1;
				border: 2px solid rgba(74, 52, 40, 0.24);
				border-radius: 20px;
				padding: 12px 14px;
				font-size: 15px;
				outline: none;
				background: #fff;
				color: #4a3428;
				resize: none;
				overflow: hidden;
				line-height: 1.45;
				min-height: 46px;
				max-height: 140px;
			}

			.bc-input:focus {
				border-color: #5f8f52;
				box-shadow: 0 0 0 3px rgba(172, 219, 163, 0.34);
			}

			.bc-send {
				height: 46px;
				border: 0;
				border-radius: 999px;
				padding: 0 16px;
				background: #4a3428;
				color: #f8f4ef;
				font-weight: 600;
				cursor: pointer;
				transition: opacity 160ms ease, transform 160ms ease;
			}

			.bc-send:disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}

			.bc-send:not(:disabled):hover {
				transform: translateY(-1px);
			}

			.bc-send:active {
				transform: translateY(0);
			}

			.bc-typing {
				display: inline-flex;
				gap: 5px;
				align-items: center;
			}

			.bc-typing span {
				width: 6px;
				height: 6px;
				border-radius: 999px;
				background: #6a4b39;
				animation: bc-bounce 1.2s infinite ease-in-out;
			}

			.bc-typing span:nth-child(2) {
				animation-delay: 0.16s;
			}

			.bc-typing span:nth-child(3) {
				animation-delay: 0.32s;
			}

			@keyframes bc-bounce {
				0%, 80%, 100% {
					transform: translateY(0);
					opacity: 0.45;
				}
				40% {
					transform: translateY(-4px);
					opacity: 1;
				}
			}

			@keyframes bc-panel-in {
				from {
					opacity: 0;
					transform: translateY(10px) scale(0.98);
				}
				to {
					opacity: 1;
					transform: translateY(0) scale(1);
				}
			}

			@keyframes bc-message-in {
				from {
					opacity: 0;
					transform: translateY(8px);
				}
				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			@keyframes bc-float {
				0%, 100% {
					transform: translateY(0);
				}
				50% {
					transform: translateY(-3px);
				}
			}

			@media (prefers-reduced-motion: reduce) {
				.bc-button,
				.bc-panel.open,
				.bc-message,
				.bc-typing span {
					animation: none !important;
					transition: none !important;
				}
			}
		`;

		document.head.appendChild(style);
	}

	function normalizeText(value) {
		if (value == null) return "";
		if (typeof value === "string") return value.trim();
		if (typeof value === "number" || typeof value === "boolean") return String(value);
		if (Array.isArray(value)) {
			return value.map(normalizeText).filter(Boolean).join("\n");
		}
		if (typeof value === "object") {
			return (
				value.answer ||
				value.message ||
				value.reply ||
				value.text ||
				value.content ||
				value.output ||
				JSON.stringify(value)
			);
		}
		return String(value);
	}

	async function readResponse(response) {
		const contentType = response.headers.get("content-type") || "";
		if (contentType.includes("application/json")) {
			const json = await response.json();
			return normalizeText(json);
		}

		const text = await response.text();
		try {
			return normalizeText(JSON.parse(text));
		} catch {
			return text.trim();
		}
	}

	function getStatusEndpoint(settings) {
		if (typeof settings.statusEndpoint === "string" && settings.statusEndpoint.trim()) {
			return settings.statusEndpoint.trim();
		}

		if (!settings.endpoint || typeof settings.endpoint !== "string") {
			return "/api/chat/status";
		}

		try {
			const endpointUrl = new URL(settings.endpoint, window.location.href);
			if (endpointUrl.pathname.endsWith("/api/chat")) {
				endpointUrl.pathname = endpointUrl.pathname.replace(/\/api\/chat$/, "/api/chat/status");
			} else {
				endpointUrl.pathname = "/api/chat/status";
			}
			endpointUrl.search = "";
			endpointUrl.hash = "";
			return endpointUrl.toString();
		} catch {
			return "/api/chat/status";
		}
	}

	function queryMetaContent(selector) {
		const node = document.querySelector(selector);
		const value = node?.getAttribute("content") || "";
		return value.trim();
	}

	function normalizeProductHandle(pathname) {
		const match = String(pathname || "").match(/\/products\/([^/?#]+)/i);
		return match ? decodeURIComponent(match[1]) : "";
	}

	function getCurrentPageContext() {
		const pathname = window.location.pathname || "";
		const pageType = /\/products\//i.test(pathname) ? "product" : "generic";
		const shopifyMetaProduct = window.ShopifyAnalytics?.meta?.product || window.meta?.product || null;

		const productTitleFromDom =
			document.querySelector("h1")?.textContent?.trim() ||
			queryMetaContent('meta[property="og:title"]') ||
			"";

		const productPriceFromDom =
			queryMetaContent('meta[property="product:price:amount"]') ||
			document.querySelector('[itemprop="price"]')?.getAttribute("content") ||
			document.querySelector('[itemprop="price"]')?.textContent?.trim() ||
			"";

		const context = {
			url: window.location.href,
			path: pathname,
			title: document.title || "",
			pageType,
		};

		if (pageType === "product") {
			context.product = {
				handle: normalizeProductHandle(pathname),
				id: String(shopifyMetaProduct?.id || ""),
				title: String(shopifyMetaProduct?.title || productTitleFromDom || ""),
				vendor: String(shopifyMetaProduct?.vendor || ""),
				price: String(shopifyMetaProduct?.price || productPriceFromDom || ""),
				currency: String(shopifyMetaProduct?.currency || queryMetaContent('meta[property="product:price:currency"]') || ""),
			};
		}

		return context;
	}

	function buildPromptWithPageContext(message, pageContext) {
		const lines = [
			"Tu es l'assistant de la boutique Benedetti.",
			"Utilise le message client ET le contexte de la page pour repondre de facon precise.",
			"",
			"[MESSAGE_CLIENT]",
			String(message || ""),
			"",
			"[CONTEXTE_PAGE]",
			`url: ${pageContext.url || ""}`,
			`path: ${pageContext.path || ""}`,
			`title: ${pageContext.title || ""}`,
			`page_type: ${pageContext.pageType || "generic"}`,
		];

		if (pageContext.product) {
			lines.push("", "[CONTEXTE_PRODUIT]");
			lines.push(`product_handle: ${pageContext.product.handle || ""}`);
			lines.push(`product_id: ${pageContext.product.id || ""}`);
			lines.push(`product_title: ${pageContext.product.title || ""}`);
			lines.push(`product_vendor: ${pageContext.product.vendor || ""}`);
			lines.push(`product_price: ${pageContext.product.price || ""}`);
			lines.push(`product_currency: ${pageContext.product.currency || ""}`);
		}

		return lines.join("\n").trim();
	}

	function createTypingIndicator() {
		const node = document.createElement("div");
		node.className = "bc-message bot";
		node.innerHTML = '<span class="bc-typing"><span></span><span></span><span></span></span>';
		return node;
	}

	function escapeAttribute(value) {
		return String(value)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/\"/g, "&quot;")
			.replace(/'/g, "&#39;");
	}

	function escapeHtml(value) {
		return String(value)
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/\"/g, "&quot;")
			.replace(/'/g, "&#39;");
	}

	function parseInlineMarkdown(text, context = {}) {
		let output = escapeHtml(text);
		const links = context.links || [];
		const images = context.images || [];

		// Handle patterns like [Label ![Alt](img)](href) before generic image/link parsing.
		output = output.replace(
			/\[([^\]]*?)!\[([^\]]*)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)\]\((https?:\/\/[^\s)]+|\/[^\s)]+|mailto:[^\s)]+|tel:[^\s)]+)\)/g,
			(_match, label, alt, imgSrc, href) => {
				const cleanLabel = String(label || "").trim();
				images.push({ alt, src: imgSrc });
				links.push({ label: cleanLabel || alt || href, href });
				const safeHref = escapeHtml(href);
				const safeImgSrc = escapeAttribute(imgSrc);
				const safeAlt = escapeAttribute(alt || cleanLabel || "Image produit");
				const labelHtml = cleanLabel ? `<span>${escapeHtml(cleanLabel)}</span>` : "";
				return `<a href="${safeHref}" rel="noreferrer noopener">${labelHtml}<div class="bc-image-card"><img src="${safeImgSrc}" alt="${safeAlt}" loading="lazy" /></div></a>`;
			}
		);

		output = output.replace(/!\[([^\]]*)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)/g, (_match, alt, src) => {
			images.push({ alt, src });
			const safeAlt = escapeAttribute(alt);
			const safeSrc = escapeAttribute(src);
			return `<div class="bc-image-card"><img src="${safeSrc}" alt="${safeAlt}" loading="lazy" /></div>`;
		});

		output = output.replace(/`([^`]+)`/g, "<code>$1</code>");
		output = output.replace(/\[(.*?)\]\((https?:\/\/[^\s)]+|\/[^\s)]+|mailto:[^\s)]+|tel:[^\s)]+)\)/g, (_match, label, href) => {
			links.push({ label, href });
			const safeHref = escapeHtml(href);
				return `<a href="${safeHref}" rel="noreferrer noopener">${escapeHtml(label)}</a>`;
		});
		output = output.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
		output = output.replace(/__(.+?)__/g, "<strong>$1</strong>");
		output = output.replace(/\*(.+?)\*/g, "<em>$1</em>");
		output = output.replace(/_(.+?)_/g, "<em>$1</em>");

		return output;
	}

	function normalizeTaskChoiceLabel(value) {
		const rawLabel = String(value || "").trim();
		const bracketedLabel = rawLabel.match(/^\[\s*([^\]]+?)\s*\]$/);
		if (bracketedLabel) {
			return bracketedLabel[1].trim();
		}
		return rawLabel;
	}

	function parseTaskItem(value) {
		const match = String(value || "").trim().match(/^\[([ xX])\]\s*(.*)$/);
		if (!match) return null;
		return {
			checked: match[1].toLowerCase() === "x",
			label: normalizeTaskChoiceLabel(match[2]),
		};
	}

	function parseSuggestionBlock(lines, startIndex) {
		const firstLine = String(lines[startIndex] || "").trim();
		const headerMatch = firstLine.match(/^:::suggestions\s*$/i);
		if (!headerMatch) return null;

		let index = startIndex + 1;
		const items = [];
		while (index < lines.length) {
			const candidate = String(lines[index] || "").trim();
			if (/^:::\s*$/.test(candidate)) {
				index += 1;
				break;
			}

			if (!candidate) {
				index += 1;
				continue;
			}

			const itemMatch = candidate.match(/^[-*+]\s+(.+)$/);
			if (itemMatch) {
				items.push(itemMatch[1].trim());
				index += 1;
				continue;
			}

			const numberedMatch = candidate.match(/^\d+\.\s+(.+)$/);
			if (numberedMatch) {
				items.push(numberedMatch[1].trim());
				index += 1;
				continue;
			}

			break;
		}

		if (!items.length) return null;

		return {
			endIndex: index,
			html: `<ul data-bc-task-list data-bc-suggestion-list>${items.map((item) => {
				const label = normalizeTaskChoiceLabel(item);
				return `<li><button type="button" class="bc-task-choice" data-bc-task-choice="${escapeAttribute(label)}">${parseInlineMarkdown(label)}</button></li>`;
			}).join("")}</ul>`,
		};
	}

	function markdownToHtml(markdown) {
		const lines = String(markdown).replace(/\r\n/g, "\n").split("\n");
		const blocks = [];
		const links = [];
		const images = [];
		let index = 0;

		const readParagraph = () => {
			const parts = [];
			while (index < lines.length) {
				const line = lines[index];
				if (!line.trim()) break;
				if (/^(#{1,6}\s|>\s|```|[-*+]\s|\d+\.\s)/.test(line)) break;
				parts.push(line.trim());
				index += 1;
			}
			return `<p>${parseInlineMarkdown(parts.join(" "), { links, images })}</p>`;
		};

		while (index < lines.length) {
			const line = lines[index];
			const trimmed = line.trim();

			if (!trimmed) {
				index += 1;
				continue;
			}

			if (trimmed.startsWith("```")) {
				index += 1;
				const codeLines = [];
				while (index < lines.length && !lines[index].trim().startsWith("```")) {
					codeLines.push(lines[index]);
					index += 1;
				}
				if (index < lines.length) index += 1;
				blocks.push(`<pre><code>${escapeHtml(codeLines.join("\n"))}</code></pre>`);
				continue;
			}

			const headingMatch = trimmed.match(/^(#{1,6})\s+(.*)$/);
			if (headingMatch) {
				const level = headingMatch[1].length;
				blocks.push(`<h${level}>${parseInlineMarkdown(headingMatch[2], { links, images })}</h${level}>`);
				index += 1;
				continue;
			}

			if (trimmed.startsWith(">")) {
				const quoteLines = [];
				while (index < lines.length && lines[index].trim().startsWith(">")) {
					quoteLines.push(lines[index].trim().replace(/^>\s?/, ""));
					index += 1;
				}
				blocks.push(`<blockquote>${quoteLines.map((item) => parseInlineMarkdown(item, { links, images })).join("<br>")}</blockquote>`);
				continue;
			}

			const suggestionBlock = parseSuggestionBlock(lines, index);
			if (suggestionBlock) {
				blocks.push(suggestionBlock.html);
				index = suggestionBlock.endIndex;
				continue;
			}

			if (/^\[([ xX])\]\s+/.test(trimmed)) {
				const items = [];
				while (index < lines.length) {
					const candidate = lines[index].trim();
					if (!candidate) {
						index += 1;
						continue;
					}
					if (!/^\[([ xX])\]\s+/.test(candidate)) break;
					items.push(candidate);
					index += 1;
				}

				const parsedTaskItems = items.map(parseTaskItem).filter(Boolean);
				if (parsedTaskItems.length) {
					blocks.push(`<ul data-bc-task-list>${parsedTaskItems.map((item) => {
						const choiceLabel = item.label;
						const checkedClass = item.checked ? " bc-task-choice--checked" : "";
						return `<li><button type="button" class="bc-task-choice${checkedClass}" data-bc-task-choice="${escapeAttribute(choiceLabel)}" data-bc-task-checked="${item.checked ? "1" : "0"}">${parseInlineMarkdown(choiceLabel, { links, images })}</button></li>`;
					}).join("")}</ul>`);
				}
				continue;
			}

			if (/^[-*+]\s+/.test(trimmed)) {
				const items = [];
				while (index < lines.length && /^[-*+]\s+/.test(lines[index].trim())) {
					items.push(lines[index].trim().replace(/^[-*+]\s+/, ""));
					index += 1;
				}
				const parsedTaskItems = items.map(parseTaskItem);
				const taskItems = parsedTaskItems.every(Boolean);
				if (taskItems) {
					blocks.push(`<ul data-bc-task-list>${parsedTaskItems.map((item) => {
						const choiceLabel = item.label;
						const checkedClass = item.checked ? " bc-task-choice--checked" : "";
						return `<li><button type="button" class="bc-task-choice${checkedClass}" data-bc-task-choice="${escapeAttribute(choiceLabel)}" data-bc-task-checked="${item.checked ? "1" : "0"}">${parseInlineMarkdown(choiceLabel, { links, images })}</button></li>`;
					}).join("")}</ul>`);
				} else {
					blocks.push(`<ul>${items.map((item) => `<li>${parseInlineMarkdown(item, { links, images })}</li>`).join("")}</ul>`);
				}
				continue;
			}

			if (/^\d+\.\s+/.test(trimmed)) {
				const items = [];
				while (index < lines.length && /^\d+\.\s+/.test(lines[index].trim())) {
					items.push(lines[index].trim().replace(/^\d+\.\s+/, ""));
					index += 1;
				}
				const parsedTaskItems = items.map(parseTaskItem);
				const taskItems = parsedTaskItems.every(Boolean);
				if (taskItems) {
					blocks.push(`<ol data-bc-task-list>${parsedTaskItems.map((item) => {
						const choiceLabel = item.label;
						const checkedClass = item.checked ? " bc-task-choice--checked" : "";
						return `<li><button type="button" class="bc-task-choice${checkedClass}" data-bc-task-choice="${escapeAttribute(choiceLabel)}" data-bc-task-checked="${item.checked ? "1" : "0"}">${parseInlineMarkdown(choiceLabel, { links, images })}</button></li>`;
					}).join("")}</ol>`);
				} else {
					blocks.push(`<ol>${items.map((item) => `<li>${parseInlineMarkdown(item, { links, images })}</li>`).join("")}</ol>`);
				}
				continue;
			}

			blocks.push(readParagraph());
		}

		return {
			html: blocks.join(""),
			links,
			images,
		};
	}

	function buildHoverDescription(markdownText, href, label) {
		const cleaned = String(markdownText)
			.replace(/!\[[^\]]*\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)/g, "")
			.replace(/\[(.*?)\]\((https?:\/\/[^\s)]+|\/[^\s)]+|mailto:[^\s)]+|tel:[^\s)]+)\)/g, "$1")
			.replace(/[#>*_`\-]+/g, " ")
			.replace(/\s+/g, " ")
			.trim();

		if (cleaned) {
			return cleaned.length > 140 ? `${cleaned.slice(0, 140).trim()}...` : cleaned;
		}

		return label || href;
	}

	const remotePreviewCache = new Map();
	const remotePreviewPromiseCache = new Map();

	function isBenedettiProductUrl(href) {
		try {
			const parsedUrl = new URL(href, window.location.href);
			return /(^|\.)benedetti\.bio$/i.test(parsedUrl.hostname) && /\/products\//i.test(parsedUrl.pathname);
		} catch {
			return false;
		}
	}

	function extractProductPreviewImage(html, pageUrl) {
		const parsedDocument = new DOMParser().parseFromString(html, "text/html");
		const selectors = [
			'meta[property="og:image:secure_url"]',
			'meta[property="og:image"]',
			'meta[name="twitter:image"]',
			'meta[property="twitter:image"]',
			'link[rel="image_src"]',
		];

		for (const selector of selectors) {
			const element = parsedDocument.querySelector(selector);
			const value = element?.getAttribute("content") || element?.getAttribute("href");
			if (!value) continue;
			try {
				return new URL(value, pageUrl).href;
			} catch {
				return value;
			}
		}

		return null;
	}

	async function loadRemotePreviewImage(href, label) {
		const normalizedUrl = new URL(href, window.location.href).href;
		if (remotePreviewCache.has(normalizedUrl)) {
			return remotePreviewCache.get(normalizedUrl);
		}

		if (remotePreviewPromiseCache.has(normalizedUrl)) {
			return remotePreviewPromiseCache.get(normalizedUrl);
		}

		const previewPromise = (async () => {
			if (!isBenedettiProductUrl(normalizedUrl)) {
				remotePreviewCache.set(normalizedUrl, null);
				return null;
			}

			try {
				const response = await fetch(normalizedUrl, {
					method: "GET",
					credentials: "omit",
					redirect: "follow",
				});

				if (!response.ok) {
					remotePreviewCache.set(normalizedUrl, null);
					return null;
				}

				const html = await response.text();
				const imageUrl = extractProductPreviewImage(html, normalizedUrl);
				if (!imageUrl) {
					remotePreviewCache.set(normalizedUrl, null);
					return null;
				}

				const preview = {
					src: imageUrl,
					alt: label || "Aperçu du produit",
				};
				remotePreviewCache.set(normalizedUrl, preview);
				return preview;
			} catch {
				remotePreviewCache.set(normalizedUrl, null);
				return null;
			}
		})();

		remotePreviewPromiseCache.set(normalizedUrl, previewPromise);
		try {
			return await previewPromise;
		} finally {
			remotePreviewPromiseCache.delete(normalizedUrl);
		}
	}

	function attachRemotePreview(linkElement, href, label) {
		const popover = linkElement.querySelector(".bc-link-popover");
		const imageBox = linkElement.querySelector(".bc-link-popover__image");
		if (!popover || !imageBox) return;

		const hydratePreview = async () => {
			if (linkElement.dataset.bcPreviewHydrated === "true") return;
			linkElement.dataset.bcPreviewHydrated = "loading";
			const preview = await loadRemotePreviewImage(href, label);
			if (!preview) {
				linkElement.dataset.bcPreviewHydrated = "false";
				return;
			}

			imageBox.hidden = false;
			imageBox.innerHTML = `<img src="${escapeAttribute(preview.src)}" alt="${escapeAttribute(preview.alt || label)}" loading="lazy" />`;
			linkElement.dataset.bcPreviewHydrated = "true";
		};

		linkElement.addEventListener("mouseenter", () => {
			void hydratePreview();
		});
		linkElement.addEventListener("focus", () => {
			void hydratePreview();
		});
			linkElement.addEventListener("click", (event) => {
				if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) return;
				event.preventDefault();
				const nextState = readChatState() || { id: createSessionId(), open: true, messages: [] };
				nextState.open = true;
				writeChatState(nextState);
				window.location.assign(href);
			});
	}

	function init(config = {}) {
		if (!document.body) {
			document.addEventListener("DOMContentLoaded", () => init(config), { once: true });
			return;
		}

		if (document.getElementById(ROOT_ID)) return;

		const settings = {
			...DEFAULT_CONFIG,
			...(window.BenedettiChatWidgetConfig || {}),
			...config,
		};
		injectStyles();

		const root = document.createElement("div");
		root.id = ROOT_ID;
		root.style.visibility = "hidden";
		root.style.display = "none";
		const storedState = readChatState();
		const chatState = {
			id: storedState?.id || (settings.clientId && settings.clientId !== DEFAULT_CONFIG.clientId ? settings.clientId : createSessionId()),
			open: storedState?.open ?? false,
			messages: storedState?.messages?.length ? [...storedState.messages] : [{ role: "bot", text: settings.welcomeMessage }],
		};
		writeChatState(chatState);
		root.innerHTML = `
			<div class="bc-panel" aria-label="Chat widget" role="dialog" aria-modal="false">
				<div class="bc-header">
					<p class="bc-title">${settings.title}</p>
					<p class="bc-subtitle">Posez votre question et obtenez une réponse immédiate</p>
					<button class="bc-reset-button" type="button" aria-label="Réinitialiser la conversation">↺</button>
				</div>
				<div class="bc-messages"></div>
				<div class="bc-footer">
					<form class="bc-form">
						<textarea class="bc-input" rows="1" placeholder="${settings.placeholder}" autocomplete="off"></textarea>
						<button class="bc-send" type="submit">Envoyer</button>
					</form>
				</div>
			</div>
			<button class="bc-button" type="button" aria-label="Ouvrir le chat">
					<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
					<path d="M20 13.5C20 16.5376 17.5376 19 14.5 19H9.25L5 21V13.5C5 10.4624 7.46243 8 10.5 8H14.5C17.5376 8 20 10.4624 20 13.5Z" fill="currentColor" opacity="0.18"/>
					<path d="M20 13.5C20 16.5376 17.5376 19 14.5 19H9.25L5 21V13.5C5 10.4624 7.46243 8 10.5 8H14.5C17.5376 8 20 10.4624 20 13.5Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/>
					<path d="M9 12.5H15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
					<path d="M9 15.5H12.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
				</svg>
			</button>
		`;
		document.body.appendChild(root);

		const panel = root.querySelector(".bc-panel");
		const button = root.querySelector(".bc-button");
		const resetButton = root.querySelector(".bc-reset-button");
		const messages = root.querySelector(".bc-messages");
		const form = root.querySelector(".bc-form");
		const input = root.querySelector(".bc-input");
		const sendButton = root.querySelector(".bc-send");
		let isWidgetVisible = true;
		let isMaintenanceMode = false;
		let maintenanceMessage = "Le chatbot est temporairement indisponible (maintenance).";
		let restoreResponseAnchor = null;
		let hasPendingRestoreScroll = false;

		const persistState = () => {
			writeChatState(chatState);
		};

		const renderConversation = () => {
			messages.innerHTML = "";
			restoreResponseAnchor = null;
			chatState.messages.forEach((message) => {
				const bubble = appendMessage(message.text, message.role, { persist: false });
				if (message.role === "bot" || message.role === "error") {
					restoreResponseAnchor = bubble;
				}
			});
			hasPendingRestoreScroll = true;
			applyRestoreScrollIfNeeded();
		};

		const applyRestoreScrollIfNeeded = () => {
			if (!hasPendingRestoreScroll) return;
			if (!panel.classList.contains("open")) return;
			if (!isWidgetVisible) return;
			if (root.style.display === "none") return;

			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
				if (restoreResponseAnchor) {
					const messagesRect = messages.getBoundingClientRect();
					const anchorRect = restoreResponseAnchor.getBoundingClientRect();
					const deltaToTop = anchorRect.top - messagesRect.top;
					messages.scrollTop = Math.max(0, messages.scrollTop + deltaToTop - 6);
				} else {
					messages.scrollTop = messages.scrollHeight;
				}
				hasPendingRestoreScroll = false;
				});
			});
		};

		const scrollMessageToStart = (bubble) => {
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					const messagesRect = messages.getBoundingClientRect();
					const bubbleRect = bubble.getBoundingClientRect();
					const deltaToTop = bubbleRect.top - messagesRect.top;
					messages.scrollTop = Math.max(0, messages.scrollTop + deltaToTop - 6);
				});
			});
		};

		const appendMessage = (text, kind, options = {}) => {
			const bubble = document.createElement("div");
			bubble.className = `bc-message ${kind}`;
			if (kind === "bot") {
				const rendered = markdownToHtml(text);
				bubble.innerHTML = rendered.html;
				bubble.querySelectorAll("a").forEach((linkElement) => {
					const href = linkElement.getAttribute("href") || "";
					const label = linkElement.textContent || href;
					linkElement.classList.add("bc-link-button");
					linkElement.setAttribute("role", "button");
					linkElement.style.position = "relative";
					linkElement.innerHTML = `${escapeHtml(label)}<span class="bc-link-popover"><span class="bc-link-popover__image" hidden></span><span class="bc-link-popover__content"><span class="bc-link-popover__title">${escapeHtml(label)}</span><span class="bc-link-popover__desc">${escapeHtml(buildHoverDescription(text, href, label))}</span></span></span>`;
					attachRemotePreview(linkElement, href, label);
				});
				bubble.querySelectorAll(".bc-task-choice").forEach((choiceButton) => {
					choiceButton.addEventListener("click", () => {
						const choice = choiceButton.getAttribute("data-bc-task-choice") || choiceButton.textContent || "";
						input.value = choice;
						resizeInput();
						form.requestSubmit();
					});
				});
			} else {
				bubble.textContent = text;
			}
			messages.appendChild(bubble);
			if (options.scrollToStart) {
				scrollMessageToStart(bubble);
			} else {
				messages.scrollTop = messages.scrollHeight;
			}
			if (options.persist !== false) {
				chatState.messages.push({ role: kind, text });
				persistState();
			}
			return bubble;
		};

		const resizeInput = () => {
			input.style.height = "auto";
			const nextHeight = Math.min(input.scrollHeight, 140);
			input.style.height = `${Math.max(nextHeight, 46)}px`;
			input.style.overflowY = input.scrollHeight > 140 ? "auto" : "hidden";
		};

		const togglePanel = () => {
			panel.classList.toggle("open");
			chatState.open = panel.classList.contains("open");
			persistState();
			if (panel.classList.contains("open")) {
				applyRestoreScrollIfNeeded();
				input.focus();
				resizeInput();
			}
		};

		button.addEventListener("click", togglePanel);
		resetButton.addEventListener("click", () => {
			chatState.id = createSessionId();
			chatState.open = true;
			chatState.messages = [{ role: "bot", text: settings.welcomeMessage }];
			persistState();
			renderConversation();
			panel.classList.add("open");
			input.value = "";
			resizeInput();
			input.focus();
		});
		input.addEventListener("input", resizeInput);
		input.addEventListener("keydown", (event) => {
			if (event.key === "Enter" && !event.shiftKey) {
				event.preventDefault();
				form.requestSubmit();
			}
		});
		resizeInput();

		renderConversation();
		if (chatState.open) {
			panel.classList.add("open");
			applyRestoreScrollIfNeeded();
		}

		const setWidgetVisibility = (visible) => {
			isWidgetVisible = Boolean(visible);
			root.style.display = isWidgetVisible ? "" : "none";
			root.style.visibility = isWidgetVisible ? "visible" : "hidden";
			if (!isWidgetVisible) {
				panel.classList.remove("open");
				chatState.open = false;
				persistState();
			} else {
				applyRestoreScrollIfNeeded();
			}
		};

		const finalizeInitialVisibility = () => {
			if (isWidgetVisible) {
				root.style.display = "";
				root.style.visibility = "visible";
				applyRestoreScrollIfNeeded();
			} else {
				root.style.display = "none";
				root.style.visibility = "hidden";
			}
		};

		const setMaintenanceMode = (enabled, message = maintenanceMessage) => {
			isMaintenanceMode = Boolean(enabled);
			maintenanceMessage = message || maintenanceMessage;
			sendButton.disabled = isMaintenanceMode;
			input.disabled = isMaintenanceMode;
			input.placeholder = isMaintenanceMode ? maintenanceMessage : settings.placeholder;
			if (isMaintenanceMode) {
				const alreadyShown = chatState.messages.some(
					(item) => item.role === "error" && item.text === maintenanceMessage
				);
				if (!alreadyShown) {
					appendMessage(maintenanceMessage, "error");
				}
			}
		};

		const refreshChatAvailability = async () => {
			try {
				const statusEndpoint = getStatusEndpoint(settings);
				const response = await fetch(statusEndpoint, {
					method: "GET",
					headers: {
						Accept: "application/json",
					},
				});

				if (!response.ok) return;
				const status = await response.json();
				if (!status || typeof status !== "object") return;

				if (typeof status.visible === "boolean") {
					setWidgetVisibility(status.visible);
				}

				if (typeof status.chatEnabled === "boolean") {
					setMaintenanceMode(!status.chatEnabled);
				} else if (status.maintenance) {
					setMaintenanceMode(true);
				}
			} catch {
				// Ignore status failures to keep widget available.
			} finally {
				finalizeInitialVisibility();
			}
		};

		void refreshChatAvailability();

		form.addEventListener("submit", async (event) => {
			event.preventDefault();
			if (!isWidgetVisible) {
				return;
			}
			if (isMaintenanceMode) {
				appendMessage(maintenanceMessage, "error");
				return;
			}
			const message = input.value.trim();
			if (!message) return;

			appendMessage(message, "user");
			input.value = "";
			resizeInput();
			input.focus();

			const typing = createTypingIndicator();
			messages.appendChild(typing);
			messages.scrollTop = messages.scrollHeight;

			sendButton.disabled = true;
			input.disabled = true;

			try {
				const formData = new FormData();
				const pageContext = getCurrentPageContext();
				const usePageContext = settings.includePageContext !== false;
				const promptMessage = usePageContext ? buildPromptWithPageContext(message, pageContext) : message;

				formData.append("message", promptMessage);
				formData.append("user_message", message);
				formData.append("page_context", JSON.stringify(pageContext));
				formData.append("prompt_format", "message_plus_page_context_v1");
				formData.append("id", chatState.id);

				const response = await fetch(settings.endpoint, {
					method: "POST",
					headers: {
						Accept: "application/json, text/plain, */*",
					},
					body: formData,
				});

				if (!response.ok) {
					if (response.status === 503) {
						const failedStatus = await response.json().catch(() => null);
						if (failedStatus && typeof failedStatus.visible === "boolean") {
							setWidgetVisibility(failedStatus.visible);
						}
						if (failedStatus && typeof failedStatus.chatEnabled === "boolean") {
							setMaintenanceMode(!failedStatus.chatEnabled);
						} else {
							setMaintenanceMode(true);
						}
					}
					throw new Error(`La requête a échoué avec le statut ${response.status}`);
				}

				const reply = await readResponse(response);
				typing.remove();
				appendMessage(reply || "Je n'ai pas reçu de réponse.", "bot", { scrollToStart: true });
			} catch (error) {
				typing.remove();
				appendMessage(
					error instanceof Error ? error.message : "Une erreur est survenue lors de l'envoi du message.",
					"error"
				);
			} finally {
				sendButton.disabled = isMaintenanceMode;
				input.disabled = isMaintenanceMode;
				if (!isMaintenanceMode && isWidgetVisible) {
					input.focus();
				}
			}
		});

		window.BenedettiChatWidget = {
			init,
			open: () => panel.classList.add("open"),
			close: () => panel.classList.remove("open"),
			toggle: togglePanel,
			send: async (message) => {
				input.value = message;
				form.requestSubmit();
			},
		};
	}

	window.BenedettiChatWidget = window.BenedettiChatWidget || {};
	window.BenedettiChatWidget.init = init;
	window.BenedettiChatWidget.open = () => document.getElementById(ROOT_ID)?.querySelector(".bc-panel")?.classList.add("open");
	window.BenedettiChatWidget.close = () => document.getElementById(ROOT_ID)?.querySelector(".bc-panel")?.classList.remove("open");
	window.BenedettiChatWidget.toggle = () => document.getElementById(ROOT_ID)?.querySelector(".bc-panel")?.classList.toggle("open");
	window.BenedettiChatWidget.send = async (message) => {
		init();
		const root = document.getElementById(ROOT_ID);
		const input = root?.querySelector(".bc-input");
		const form = root?.querySelector(".bc-form");
		if (!input || !form) return;
		input.value = message;
		form.requestSubmit();
	};

	init();
})();
